import { useMutation } from "react-apollo"
import gql from "graphql-tag"
import { useTriggerErrorAlert } from "@modules/ui/components/ErrorAlert"
import { useCurrentUser } from "@modules/auth"

const TOGGLE_INCREMENTAL_BUILDS = gql`
  mutation toggleIncrementalBuildFlag($siteId: UUID!) {
    toggleIncrementalBuildFlag(siteId: $siteId) {
      success
      message
    }
  }
`

export default function useToggleIncrementalBuilds(siteId) {
  const { currentUser } = useCurrentUser()
  const currentUserId = currentUser && currentUser.id

  const [mutation, { loading }] = useMutation(TOGGLE_INCREMENTAL_BUILDS)
  const [setError, errorAlert] = useTriggerErrorAlert()

  const toggleIncrementalBuilds = () => {
    setError(null)
    return mutation({
      variables: {
        siteId,
        userId: currentUserId,
      },
      update: updateIncrementalBuildsEnabledCache(siteId),
      optimisticResponse: {
        toggleIncrementalBuildFlag: {
          success: true,
          message: null,
          __typename: `MutationResult`,
        },
      },
    }).catch(err => setError(err))
  }

  return [toggleIncrementalBuilds, { loading, errorAlert }]
}

function updateIncrementalBuildsEnabledCache(siteId) {
  return (proxy, { data }) => {
    if (!data.toggleIncrementalBuildFlag.success) {
      return
    }
    const fragmentInfo = {
      id: `Site:${siteId}`,
      fragment: gql`
        fragment siteDetailsIncrementalBuildsFrag on Site {
          id
          incrementalBuildsEnabled
        }
      `,
    }

    const site = proxy.readFragment(fragmentInfo)

    site.incrementalBuildsEnabled = !site.incrementalBuildsEnabled

    proxy.writeFragment({
      ...fragmentInfo,
      data: site,
    })
  }
}
